import moment from "moment/moment";

const formattedDate = date => moment(date).format("D MMMM YYYY");

export {
    formattedDate,
}